import { AxiosError, AxiosResponse } from "axios";
import { ResponseMessagesEnum } from "../../interfaces/Enums";
import { api } from "../../services/api";
import { useAlertError } from "../../store/AlertError";
import { useGlobalLoading } from "../../store/GlobalLoading";
import { useSignUp } from "../../store/SignUp";

export function useAuthGenerateCode() {
  const { openAlert } = useAlertError();
  const { openLoading, closeLoading } = useGlobalLoading();
  const { setEmail, setCode } = useSignUp();

  async function generateCode(email: string) {
    openLoading();

    try {
      const response = await api.post("/email/generate", { email });
      setEmail(email);
      handleResponse(response);
    } catch (error: AxiosError | any) {
      handleError(
        ResponseMessagesEnum.ErrorSendCode,
        error.response?.data?.message
      );
    }
  }

  function handleResponse(response: AxiosResponse): void {
    if (response.status === 200) {
      setCode(response.data);
      openAlert({
        message: ResponseMessagesEnum.SuccessSendCode,
        status: "success",
      });
      closeLoading();
    } else {
      throw new Error(response.data.message);
    }
  }

  function handleError(
    defaultMessage: ResponseMessagesEnum,
    message?: string
  ): void {
    openAlert({
      message: message ? message : defaultMessage,
      status: "error",
    });
    closeLoading();
  }

  return { generateCode };
}
